<template>
  <div class="ProductList flex">
    <div class="sidebar">
      <sidebar />
    </div>
    <div class="contentList">
      <router-view></router-view>
      <transition name="slide-fade">
        <!-- 所有车辆 -->
        <all-type :productInfoData="productInfoList" v-if="$store.state.productListMenuItem == 1" />
      </transition>

      <transition name="slide-fade">
        <!-- 环卫车辆 -->
        <environmental-sanitation-car :data="dataList" @update="getData" v-if="$store.state.productListMenuItem == 2" />
      </transition>

      <transition name="slide-fade">
        <!-- 压缩设备 -->
        <compressor :data="dataList" @update="getData" v-if="$store.state.productListMenuItem == 3" />
      </transition>

      <transition name="slide-fade">
        <!-- 环保设备 -->
        <environmental-sanitation-equipment
          :data="dataList"
          @update="getData"
          v-if="$store.state.productListMenuItem == 4"
        />
      </transition>
      <transition name="slide-fade">
        <!-- 环保设备 -->
        <environmental-sanitation-box :data="dataList" @update="getData" v-if="$store.state.productListMenuItem == 5" />
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productInfoList: {
      type: Array,
      required: true,
      default: () => {
        return {};
      },
    },
  },
  created() {},
  name: "",
  data() {
    return {
      activeIndex: "",
      imgUrl: this.$store.state.imgUrl,
      productInfo: [],
      dataList: [],
      // searchSta: this.$store.state.isSearch,
    };
  },
  components: {
    Sidebar: () => import("../ProductList/Sidebar"),
    AllType: () => import("../ProductList/ModelType/AllType"),
    Compressor: () => import("../ProductList/ModelType/Compressor"),
    EnvironmentalSanitationCar: () => import("../ProductList/ModelType/EnvironmentalSanitationCar"),
    EnvironmentalSanitationEquipment: () => import("../ProductList/ModelType/EnvironmentalSanitationEquipment"),
    EnvironmentalSanitationBox: () => import("../ProductList/ModelType/EnvironmentalSanitationBox"),
  },
  computed: {
    isToggle() {
      return this.$store.state.productListMenuItem;
    },
    searchVal() {
      return this.$store.state.searchInput;
    },
    getDataStatus() {
      return this.$store.state.isGetData;
    },
  },
  watch: {
    isToggle(val) {
      console.log(val);
      this.getData();
    },
    searchVal(val) {
      this.getData(val);
    },
    getDataStatus(val) {
      console.log(val);
      if (val == true) {
        this.updateData();
      }
    },
  },
  methods: {
    async getData(type) {
      if (this.$store.state.isSearch) {
        console.log(1);
        const { data: res } = await this.$http.get("/productInfo/list", {
          params: {
            type: 1,
            value: type,
          },
        });
        // this.productInfoList = res.result.productInfo;
        this.$emit("update:productInfoList", res.result.productInfo);
        this.$store.state.isSearch = false;
      } else {
        setTimeout(async () => {
          const { data: res } = await this.$http.get("/productInfo/list", {
            params: { 
              type: this.$store.state.productListMenuItem,
              value: "",
            },
          });
          this.dataList = res.result.productInfo;
        }, 200);
      }
    },
    async updateData() {
      const { data: res } = await this.$http.get("/productInfo/list", {
        params: {
          type: this.isToggle,
          value: "",
        },
      });
      // this.productInfoList = res.result.productInfo;
      this.$emit("update:productInfoList", res.result.productInfo);
    },
  },
};
</script>

<style scoped lang="less">
.slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(300px);
  opacity: 0.1;
}
.ProductList {
  width: 100%;
  margin-top: 50px;
  .sidebar {
    width: 15%;
    height: 100%;
  }
  .contentList {
    width: 85%;
    height: 100%;
    padding: 0 100px 0 100px;
    border-left: 3px solid #1bbabe;
  }
}
</style>
